import * as DateHelper from 'utils/DateHelper';

export default {
  mandatory(field, value, mandatory) {
    return new Promise((resolve, reject) => {
      if (!mandatory) resolve();

      const valueIsEmpty = value === null || value === undefined || value.toString().trim() === '';
      if (!valueIsEmpty) resolve();
      reject(`is a required field`);
    });
  },
  validDate(field, value, mandatory) {
    const date = DateHelper.createDate(value);
    return new Promise((resolve, reject) => {
      if (!mandatory || (mandatory && date.isValid())) {
        resolve();
      } else {
        reject(`is not a valid date`);
      }
    });
  },
  minLength(field, value, minLength) {
    return new Promise((resolve, reject) => {
      if ((minLength && value && value.length >= minLength) || !minLength) {
        resolve();
      } else {
        reject(`has a minimum length of ${minLength} characters`);
      }
    });
  },
  maxLength(field, value, maxLength) {
    return new Promise((resolve, reject) => {
      if ((maxLength && value && value.length <= maxLength) || !maxLength) {
        resolve();
      } else {
        reject(`has a maximum length of ${maxLength} characters`);
      }
    });
  },

  pattern: (field, value, pattern) => {
    if (!value) return false;
    const regex = new RegExp(pattern);
    return !regex.test(value);
  },

  numeric(field, value) {
    return new Promise((resolve, reject) => {
      const valueIsEmpty = value === null || value === undefined || value.toString().trim() === '';
      if (valueIsEmpty) resolve();
      const regex = new RegExp('^[-+]?\\d*\\.?\\d*$');
      if (regex.test(value)) resolve();
      reject(`should only contain numbers 0-9`);
    });
  },
};
